import React, { useState, useContext, useEffect } from "react";
import "./splitBillOptions.scss";
import { useHistory } from "react-router-dom";

// material ui
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux


function SplitBillOptions(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);


  useEffect(() => {
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: Boolean(localStorage.getItem("splitBillOptions")),
    });

    appDispatch({
      type: "setPayForItems",
      payForItems: Boolean(localStorage.getItem("payForItems")),
    });

    appDispatch({
      type: "setDivideBill",
      divideBill: Boolean(localStorage.getItem("divideBill")),
    });

    appDispatch({
      type: "setPayCustomAmount",
      payCustomAmount: Boolean(localStorage.getItem("payCustomAmount")),
    });

  }, [])

  const handleShowPayForItems = () => {
    appDispatch({
      type: "setPayForItems",
      payForItems: true,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: false,
    });
    localStorage.setItem("payForItems", Boolean(true))
    localStorage.removeItem("splitBillOptions")
  }

  const handleShowDivideBill = () => {
    appDispatch({
      type: "setDivideBill",
      divideBill: true,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: false,
    });
    localStorage.setItem("divideBill", true)
    localStorage.removeItem("splitBillOptions")
  }

  const handleShowPayCustomAmount = () => {
    appDispatch({
      type: "setPayCustomAmount",
      payCustomAmount: true,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: false,
    });
    localStorage.setItem("payCustomAmount", true)
    localStorage.removeItem("splitBillOptions")

  }

  return (
    <div id="mySidenav" className={`splitBillOptions     ${appState.langValue == "ar" ? "splitBillOptionsArabic" : " "
      }`}>

      <div className="container-fluid content px-4 pb-3 my-5">
        <h1 className={` ${appState.langValue === "ar" ? "text-right familyGraphikArabic800 " : " familyPoppins600"
          }`}
        >{t("invoice.Split-Bill")}</h1>
        <div className="row mt-3 px-2">
         {false && <Button onClick={handleShowPayForItems} className={`py-3 px-4 d-flex justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600 " : ""
            }`}

          ><span className="text-capitalize" >{t("invoice.Pay-for-your-items")}</span>  </Button>}
          <Button onClick={handleShowDivideBill} className={` py-3 px-4 mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
            }`}

          > <span className="text-capitalize">{t("invoice.Divide-the-bill-equally")}</span>  </Button>
          <Button onClick={handleShowPayCustomAmount} className={` py-3 px-4 mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
            }`}

          > <span className="text-capitalize">{t("invoice.Pay-a-custom-amount")}</span>  </Button>
        </div>
      </div>

    </div>


  );
}



export default withTranslation()(SplitBillOptions);